import * as React from "react";
import { useGlobalState } from "../state/GlobalStateProvider";
import { Outlet, useLocation } from "react-router-dom";
import { Spinner } from "@fluentui/react-components";
import { CenteredContent } from "./CenteredContent";

export const PrivateRoute: React.FC = () => {
    const globalState = useGlobalState();
    const location = useLocation();  // Get the current location

    if (globalState.auth === undefined)
    {
        return (
            <CenteredContent>
                <Spinner />
            </CenteredContent>
        );
    }
    else if (!globalState.auth?.userDetails) {
        window.location.href = `/.auth/login/aad?post_login_redirect_uri=${location.pathname}`;
        
        return (
            <CenteredContent>
                <Spinner />
            </CenteredContent>
        );
    } else {
        return <Outlet />;
    }
};
